import { useNavigate, useNavigation } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout'; 
import logo from './images/logo.png'

function App() {
const navigation = useNavigate()
  const goHome = () => {
   localStorage.getItem('uid')
   ?
   navigation('/home')
    : console.log('not logged in')
  }
  
  return (
    <Layout>
      <div className='flex w-full h-full flex-col'>

        <div className='flex flex-1 justify-center'>
          <img src={logo} alt="logo" className='w-auto h-full' /> 
        </div>


        <div className='flex flex-1'>
          {/* login with google component image and text */}
          <div className='flex flex-1 flex-col justify-between items-start'>
            <div className='flex flex-col justify-start items-start pt-8'>
               <h1 className='text-3xl font-black text-white'>Legionario una volta,</h1>
              <h1 className='text-3xl font-black text-white'>legionario per sempre!</h1>
            </div>

{/* 
            <button
            onClick={() => postActivity(
              title,
              place,
              date,
              hour,
              meeting,
              info
              
              {titolo: 'Partita amichevole shooters', campo: 'Castel San Giorgio', orario: '07:00', appuntamento: 'Bar O professor', info: 'Non rompete il cazzo'})}
            
            
            className='bg-white text-black font-bold py-2 px-4 rounded-full'>Post Activity</button> */}
            <div className='flex w-full flex-col justify-center items-center h-full'>
             {/**login form */}

              

            </div>
          </div>

        </div>
      </div>
    </Layout>
  );
}

export default App;


